import { WebProjectItemModel } from "../../utils/types";
import {
  ProjectListContainer,
  ProjectListIcon,
  ProjectListIconContainer,
  ProjectListIconName,
} from "./ProjectListStyles";
import { ThemeProvider } from "styled-components";
import { token } from "../../../../theme";
import React from "react";
import { iconMotionProps } from "../../../../components/Effects/iconMotion";
import { getProjectIcon, useOpenProject } from "../../utils/useOpenProject";

export interface ProjectListProps {
  webProjectItems: WebProjectItemModel[];
  staggerOffset?: number;
}

const ProjectList = ({
  webProjectItems,
  staggerOffset = 0,
}: ProjectListProps) => {
  const { openProject, openProjectDetails } = useOpenProject();

  const handleProjectRightClick = (
    e: React.MouseEvent,
    project: WebProjectItemModel
  ) => {
    e.preventDefault();
    openProjectDetails(project);
  };

  return (
    <ThemeProvider theme={token}>
      <ProjectListContainer>
        {webProjectItems.map((project, index) => {
          return (
            <ProjectListIconContainer
              {...iconMotionProps(staggerOffset + index)}
              onDoubleClick={() => {
                openProject(project);
              }}
              onContextMenu={(e) => {
                handleProjectRightClick(e, project);
              }}
              key={project.title + index}
            >
              <ProjectListIcon src={getProjectIcon(project)} />
              <ProjectListIconName>
                {project.title || "Project"}
              </ProjectListIconName>
            </ProjectListIconContainer>
          );
        })}
      </ProjectListContainer>
    </ThemeProvider>
  );
};

export default ProjectList;
